const e=async(e,t,n,r)=>{let{data:{secret:i}}=await e.post(`/webhooks/${t}/${n}/${r}/secret/regenerate`);return i};export{e as regenerateWebhookSecret};
//# sourceMappingURL=regenerate-secret.mjs.map